import { IsDateString, IsOptional } from 'class-validator';
import { ConditionIndexActionType, StatisticBaseValues } from '../search';

/**
 * DTO for requesting clinical statistics for the current user.
 */
export class CurrentUserClinicalStatisticsRequestDto {
  // Optional date that will be used to filter statistics
  // If null, statistics will be calculated from the beginning of time
  @IsOptional()
  @IsDateString()
  afterDate?: string;
}

/**
 * DTO for returning clinical statistics for the current user.
 */
export interface CurrentUserClincalStatisticsResponseDto {
  afterDate?: Date;

  userTotalConditions: number;

  userStatistics: StatisticBaseValues;

  userPerformanceMetrics: ClinicalStatisticsBaseMetrics;

  // Null if too few users included in metrics
  medicalUnitMetrics: ClinicalStatisticsBaseMetrics | null;

  clinicalActionStatistics: ClinicalStatisticsActionStatistics[];

  userTotalActions: number;

  medicalUnitTotalActions: number;
}

/**
 * Statistics for a specific clinical action.
 */
export interface ClinicalStatisticsActionStatistics {
  actionType: ConditionIndexActionType;

  userCount: number;

  // Null if too few users included in metrics
  medicalUnitDistribution: number | null;
}

/**
 * Base metrics for clinical statistics. All metrics are percentages
 * in the range 0 - 1.
 */
export interface ClinicalStatisticsBaseMetrics {
  // Total number of conditions used for metrics
  // Null if confidential data
  total: number | null;

  accuracy: number;

  sensitivity: number;

  specificity: number;

  ppv: number;

  npv: number;
}
